
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class WhatIsWhereGrid extends _Ext.GridBase<WIPMovementRow, any> {
        protected getColumnsKey() { return 'Production.WhatIsWhere'; }
        protected getDialogType() { return WIPMovementDialog; }
        protected getIdProperty() { return WIPMovementRow.idProperty; }
        protected getInsertPermission() { return WIPMovementRow.insertPermission; }
        protected getLocalTextPrefix() { return WIPMovementRow.localTextPrefix; }
        protected getService() { return WhatIsWhereService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            //    this.addDateRangeFilter("TransDate", "Date");
            this.setTitle("");
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            //grid.registerPlugin(this.autoSize);
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());
          

            //this.view.setGrouping([{
               
            //    getter: 'CustomerName',
            //    displayTotalsRow: false,
                
            //}])

            return grid;
        }


        //protected updateInterface() {
        //    super.updateInterface();
        //    this.setTitle("Profit and Loss");
        //}
        protected usePager() { return true; };
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push(Common.PdfExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit(),
                reportTitle: "What is Where"
            }));

            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                service: this.getService() + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            //buttons.push({
            //    title: 'Print',
            //    icon: 'fa fa-print text-blue',
            //    //icon: 'fa-cloud-download',
            //    onClick: () => {

            //        Common.ReportHelper.execute({
            //            reportKey: 'Production.ProfitandLoss',
            //            params: {
            //                CompanyIds: this.view.params.CompanyIds,
            //                FinIds: this.view.params.FinancialYearIds,
            //                VendorIds: this.view.params.VendorIds,
            //                date: this.view.params.Criteria
            //            }
            //        });
            //    }
            //}
            //);
            return buttons;
        }
    }
}